import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const HeroSection = () => {
  const sectionRef = useRef(null);
  const textRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // 1. Video Zoom/Fade in
      gsap.fromTo(videoRef.current, 
        { scale: 1.2, opacity: 0 }, 
        { scale: 1, opacity: 1, duration: 2, ease: "power3.out" }
      );

      // 2. Text Reveal Animation (Staggered)
      const lines = textRef.current.querySelectorAll('.reveal-line');
      gsap.fromTo(lines, 
        { y: 50, opacity: 0 }, 
        { 
          y: 0, 
          opacity: 1, 
          duration: 1.2, 
          stagger: 0.3, 
          ease: "power4.out",
          delay: 0.5 
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="hero-container" ref={sectionRef}>
      {/* Background Video */}
      <div className="video-wrapper">
        <video 
          ref={videoRef}
          autoPlay 
          loop 
          muted 
          playsInline 
          className="bg-video"
        >
          <source src="/hero.mp4" type="video/mp4" />
        </video>
        <div className="overlay"></div>
      </div>

      {/* Content */}
      <div className="content-box" ref={textRef}>
        {/* <h4 className="reveal-line accent-text">About —</h4> */}
        <h1 className="reveal-line main-title">
          Driving Innovation.<br />
          Delivering<br />
          Excellence.
        </h1>
      </div>
    </section>
  );
};

export default HeroSection;